import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListEmailAddressCell } from './emsp-bo-emsp-user-list-email-address.cell';
import { EmspBoEmspUserListEmailAddressHeader } from './emsp-bo-emsp-user-list-email-address.header';

export const EmspBoEmspUserListEmailAddressColumn: IdentifiedColumnDef<
  EmspUserModel,
  EmspUserModel['emailAddress']
> = {
  enableSorting: true,
  header: EmspBoEmspUserListEmailAddressHeader,
  cell: EmspBoEmspUserListEmailAddressCell,
};
